import { Expose, Transform, Type } from 'class-transformer';
import { decorate } from 'ts-mixer';

import type { ZonedDateTime } from '@/infra/adapters/datetime';
import datetime from '@/infra/adapters/datetime';
import { hash } from '@/infra/adapters/hasher';
import {
    ApproveData,
    FileData,
    ReviewData,
    State,
    UpdateData,
    UpdateStatus,
    UpdateType,
} from '@/v1/domain/models';

export class ViewResource {
    @decorate(Expose({ name: 'key', groups: ['default'] }))
    @decorate(
        Transform(({ value, obj }) => value || hash(obj), { toClassOnly: true })
    )
    key: string | number = '';

    @decorate(Expose({ name: 'disabled', groups: ['default'] }))
    // @decorate(
    //     Transform(
    //         ({ value, obj }) =>
    //             value ||
    //             (obj.upt_status && obj.upt_status != UpdateStatus.INIT),
    //         { toClassOnly: true }
    //     )
    // )
    disabled: boolean = false;

    public constructor(obj?: any) {
        if (!obj) return;
        this.key = obj.key;
        this.disabled = obj.disabled;
    }
}

export class ApproveResource {
    @decorate(Expose({ name: 'aprv_userid', groups: ['default'] }))
    aprvUserId: string = '';
    @decorate(Expose({ name: 'aprv_user_name', groups: ['default'] }))
    aprvUserName: string = '';

    @decorate(Expose({ name: 'aprv_time', groups: ['default'] }))
    @decorate(Type(() => Date))
    @decorate(
        Transform(
            ({ value }) => {
                return isNaN(value) ? undefined : datetime.parse(value);
            },
            {
                toClassOnly: true,
            }
        )
    )
    aprvDateTime!: ZonedDateTime;

    public constructor(obj?: ApproveData) {
        if (!obj) return;
        this.aprvUserId = obj.aprvUserId;
        this.aprvUserName = obj.aprvUserName;
        this.aprvDateTime = obj.aprvDateTime;
    }
}

export class UpdateResource {
    @decorate(Expose({ name: 'upt_userid', groups: ['default', 'review'] }))
    uptUserId: string = '';
    @decorate(Expose({ name: 'upt_user_name', groups: ['default', 'review'] }))
    uptUserName: string = '';

    @decorate(Expose({ name: 'upt_time', groups: ['default', 'review'] }))
    @decorate(Type(() => Date))
    @decorate(
        Transform(
            ({ value }) => {
                return isNaN(value) ? undefined : datetime.parse(value);
            },
            {
                toClassOnly: true,
            }
        )
    )
    uptDateTime!: ZonedDateTime;

    public constructor(obj?: UpdateData) {
        if (!obj) return;
        this.uptUserId = obj.uptUserId;
        this.uptUserName = obj.uptUserName;
        this.uptDateTime = obj.uptDateTime;
    }
}

export class FileResource {
    @decorate(Expose({ name: 'input_filename', groups: ['default', 'upload'] }))
    inputFilename: string = State.NO_USE_VAL;
    @decorate(Expose({ name: 'input_userid', groups: ['default', 'upload'] }))
    inputUserId: string = State.NO_USE_VAL;
    @decorate(
        Expose({ name: 'input_user_name', groups: ['default', 'upload'] })
    )
    inputUserName: string = State.NO_USE_VAL;

    @decorate(Expose({ name: 'input_time', groups: ['default', 'upload'] }))
    @decorate(Type(() => Date))
    @decorate(
        Transform(
            ({ value }) => {
                return isNaN(value) ? undefined : datetime.parse(value);
            },
            {
                toClassOnly: true,
            }
        )
    )
    @decorate(
        Transform(
            ({ value }) => {
                return isNaN(value) ? State.NO_USE_VAL : value.toISOString();
            },
            {
                toPlainOnly: true,
            }
        )
    )
    inputDateTime!: ZonedDateTime;

    public constructor(obj?: FileData) {
        if (!obj) return;
        this.inputFilename = obj.inputFilename;
        this.inputUserId = obj.inputUserId;
        this.inputUserName = obj.inputUserName;
        this.inputDateTime = obj.inputDateTime;
    }
}

export class ReviewResource {
    @decorate(Expose({ name: 'upt_type', groups: ['default', 'review'] }))
    uptType: UpdateType = UpdateType.CREATE;

    @decorate(Expose({ name: 'upt_status', groups: ['default', 'review'] }))
    uptStatus: UpdateStatus = UpdateStatus.INIT;

    @decorate(Expose({ name: 'decline_type', groups: ['default', 'review'] }))
    declineType: string = State.NO_USE_VAL_2;

    @decorate(Expose({ name: 'decline_reason', groups: ['default', 'review'] }))
    declineReason: string = State.NO_USE_VAL;

    public constructor(obj?: ReviewData) {
        if (!obj) return;
        this.uptType = obj.uptType;
        this.uptStatus = obj.uptStatus;
        this.declineType = obj.declineType;
        this.declineReason = obj.declineReason;
    }
}
